var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfirmFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8315 3.66751C20.9762 4.81189 21.3188 6.53317 20.6994 8.02864C20.0801 9.52411 18.6209 10.4992 17.0023 10.4992C15.3836 10.4992 13.9244 9.52411 13.3051 8.02864C12.6858 6.53317 13.0284 4.81189 14.1731 3.66751C15.7357 2.10534 18.2688 2.10534 19.8315 3.66751",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3638 5.64636L16.6631 7.34707L15.6406 6.32765",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8315 14.6721C20.9762 15.8165 21.3188 17.5378 20.6994 19.0332C20.0801 20.5287 18.6209 21.5038 17.0023 21.5038C15.3836 21.5038 13.9244 20.5287 13.3051 19.0332C12.6858 17.5378 13.0284 15.8165 14.1731 14.6721C15.7357 13.1099 18.2688 13.1099 19.8315 14.6721",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 9.35591H4.13981C3.50829 9.35591 2.99634 8.84396 2.99634 8.21243V4.783C2.99634 4.15148 3.50829 3.63953 4.13981 3.63953H10.9997",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 20.3605H4.13981C3.50829 20.3605 2.99634 19.8485 2.99634 19.217V15.7876C2.99634 15.1561 3.50829 14.6441 4.13981 14.6441H10.9997",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8535 16.6509L16.1528 18.3516",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmFile);
export default __webpack_public_path__ + "static/media/confirmFile.eba6838fc40f76f0bb591d52cd29ea6e.svg";
export { ForwardRef as ReactComponent };